import { render, staticRenderFns } from "./employe-update-dialog.vue?vue&type=template&id=72ba7d1c&scoped=true"
import script from "./employe-update-dialog.vue?vue&type=script&lang=js"
export * from "./employe-update-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba7d1c",
  null
  
)

export default component.exports